import planStay from "images/tribyou_decorations/plan_stay.png";
import findTribu from "images/tribyou_decorations/find_tribu.png";
import chooseStay from "images/tribyou_decorations/choose_stay.png";
import business from "images/tribyou_decorations/business-trip.png";
import comfort from "images/tribyou_decorations/sweatshirt.png";
import authentic from "images/tribyou_decorations/shaka.png";
import SmartWalking from "images/tribyou_decorations/smart-walking.png";
import Tourism from "images/tribyou_decorations/turismo-radici.png";
import SmartHub from "images/tribyou_decorations/hub-smart.png";
// team
import luca from "images/team/luca.png";
import giancarlo from "images/team/giancarlo.png";
import vincenzo from "images/team/vincenzo.png";
import simone from "images/team/simone.png";

export const USER_JOURNEY_DATA = [
    planStay,
    findTribu,
    chooseStay,
];
  
export const TRENDS_DATA = [
    SmartWalking,
    Tourism,
    SmartHub
];
  
export const TESTIMONIALS_DATA = [
    luca,
    simone,
    giancarlo,
    vincenzo
];

export const MOOD_DATA = {
    business,
    comfort,
    authentic
}